<div class="page-container">
    <div class="page-header">
        <div class="header-content">
            <h1 class="page-title">Trucks Management</h1>
            <p class="page-subtitle">Manage your truck fleet and driver information</p>
        </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-overlay">
        <mat-spinner diameter="50" color="primary"></mat-spinner>
        <p class="loading-text">Loading trucks...</p>
    </div>

    <div class="card" [class.loading]="isLoading">
        <div class="card-header">
            <div class="search-wrapper">
                <mat-icon class="search-icon">search</mat-icon>
                <input
                    type="text"
                    class="search-input"
                    [(ngModel)]="searchText"
                    placeholder="Search by plate number..."
                />
                <mat-icon *ngIf="searchText" class="clear-icon" (click)="searchText = ''">close</mat-icon>
            </div>

            <button class="btn-primary" (click)="addNewTruck()">
                <mat-icon>add</mat-icon>
                <span>Add Truck</span>
            </button>
        </div>

        <div class="table-container" *ngIf="filteredOrders.length > 0">
            <table class="data-table">
                <thead>
                    <tr>
                        <th class="th-actions"></th>
                        <th>Truck</th>
                        <th>Plate Number</th>
                        <th>Truck Type</th>
                        <th>Contact Name</th>
                        <th>Phone Number</th>
                        <th class="th-actions">Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of pagedOrders">
                        <td class="actions-cell">
                            <button class="btn-icon-action" (click)="editTruck(data, $event)">
                                <mat-icon>more_vert</mat-icon>
                            </button>

                            <div *ngIf="selectedTruckId === data.id" class="dropdown-menu"
                                [style.top]="dropdownPosition.top"
                                [style.right]="dropdownPosition.right">
                                <button class="dropdown-item" (click)="onEdit(data)">
                                    <mat-icon class="dropdown-icon edit-icon">edit</mat-icon>
                                    Edit
                                </button>
                                <div class="dropdown-divider"></div>
                                <button class="dropdown-item dropdown-item-danger" (click)="onDelete(data)">
                                    <mat-icon class="dropdown-icon">delete</mat-icon>
                                    Delete
                                </button>
                            </div>
                        </td>
                        <td>
                            <div class="truck-photo">
                                <img *ngIf="data.profilePictureUrl; else truckPlaceholder"
                                    [src]="data.profilePictureUrl" alt="Truck Photo" class="truck-img" />
                                <ng-template #truckPlaceholder>
                                    <div class="truck-img-placeholder">
                                        <mat-icon>local_shipping</mat-icon>
                                    </div>
                                </ng-template>
                            </div>
                        </td>
                        <td>
                            <span class="cell-text">{{ data.plateNumber }}</span>
                        </td>
                        <td>
                            <span class="cell-text">{{ data.truckTypeValue?.name || '—' }}</span>
                        </td>
                        <td>
                            <span class="cell-text">{{ data.driver.khmerName || '—' }}</span>
                        </td>
                        <td>
                            <span class="cell-text">{{ data.driver?.primaryContactNumber | phoneFormat }}</span>
                        </td>
                        <td>
                            <select
                                class="status-select"
                                [ngClass]="{
                                    'status-active': data.status === 'ACTIVE',
                                    'status-inactive': data.status === 'INACTIVE',
                                    'status-in-shop': data.status === 'IN_SHOP',
                                    'status-out-of-service': data.status === 'OUT_OF_SERVICE'
                                }"
                                [(ngModel)]="data.status"
                                (ngModelChange)="updateTruckStatus(data, $event)"
                                (click)="$event.stopPropagation()">
                                <option *ngFor="let s of truckStatuses" [value]="s.value">{{ s.label }}</option>
                            </select>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="empty-state" *ngIf="filteredOrders.length === 0">
            <mat-icon class="empty-icon">local_shipping</mat-icon>
            <h3>No trucks found</h3>
            <p>{{ searchText ? 'Try adjusting your search criteria' : 'Get started by adding your first truck' }}</p>
        </div>

        <div class="card-footer" *ngIf="filteredOrders.length > 0">
            <div class="pagination-info">
                Showing <strong>{{ (currentPage - 1) * pageSize + 1 }}</strong> to
                <strong>{{ currentPage * pageSize > filteredOrders.length ? filteredOrders.length : currentPage * pageSize }}</strong>
                of <strong>{{ filteredOrders.length }}</strong> trucks
            </div>

            <div class="pagination">
                <button class="pagination-btn" [disabled]="currentPage === 1" (click)="getTruckList(currentPage - 1)">
                    <mat-icon>chevron_left</mat-icon>
                </button>

                <ng-container *ngFor="let page of pages">
                    <button
                        class="pagination-btn pagination-number"
                        [ngClass]="{ 'active': page === currentPage }"
                        (click)="getTruckList(page)">
                        {{ page }}
                    </button>
                </ng-container>

                <button class="pagination-btn" [disabled]="currentPage === totalPages" (click)="getTruckList(currentPage + 1)">
                    <mat-icon>chevron_right</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>